//#region IMPORTS
import { useHistory } from "react-router-dom";
import { ArrowRightOnRectangleIcon } from "@heroicons/react/24/outline";
import { Fragment } from "react";
import { Tooltip } from "react-tooltip";
import { Store } from "../../models/store";
import { ORDERSTATUS } from "../../models/order";
import { SHOP_TAB } from "../orders/tabs";
//#endregion

//#region INTERFACE
interface Props {
  store: Store;
}
//#endregion

export default function StoresTableRowActionGoToInstoreOrders({
  store,
}: Props) {
  //#region SETUP
  const history = useHistory();
  //#endregion

  //#region LOGIC
  // Deep-link to this store's non-Week "Ordered" instore orders. preset=all is
  // role-agnostic; status + store land as clearable filter chips; the
  // "opening-relocation" type bucket maps to exclude_order_type=Week so we land
  // on exactly the set that lit up the button.
  const goToOrders = () => {
    const params = new URLSearchParams({
      tab: SHOP_TAB.instore,
      preset: "all",
      status: ORDERSTATUS.ordered,
      type: "opening-relocation",
      store: store.external_store_id,
    });
    history.push(`/orders?${params.toString()}`);
  };
  //#endregion

  //#region RENDER
  return (
    <Fragment>
      <ArrowRightOnRectangleIcon
        data-tooltip-id={String(store.id) + "gotoorders"}
        data-tooltip-content="Opening / relocation Orders"
        data-tooltip-variant="dark"
        data-tooltip-delay-show={500}
        className="w-4 h-4 text-sky-700 hover:text-sky-500 hover:cursor-pointer"
        onClick={goToOrders}
        type="button"
      />
      <Tooltip id={String(store.id) + "gotoorders"} />
    </Fragment>
  );
  //#endregion
}
